import { createContext } from 'react'

export const SupplierOriginContext = createContext<{
  state: any
  dispatch: any
}>({ state: undefined, dispatch: undefined })
